/* eslint-disable import/prefer-default-export */
import { atom } from 'jotai';

import { User } from '../../../types/GenericInspection/user';

const initialValue: User | null = null;

const userAtom = atom<User | null>(initialValue);

export { userAtom };
